import { useContext } from 'react'
import { BackendUser, BackendPartner, UserFunction, Connection } from "common/types";
import { Receiver } from "common/types/message.types";
import { useConnectionApi } from "hooks/use-connection-api/useConnectionApi";
import MessagingContext from 'contexts/messaging/MessagingProvider'
import { usePartnerApi } from "hooks/use-partner-api/usePartnerApi";
import { useUserApi } from "hooks/use-user-api/useUserApi";
import { useUserManagementApi } from "hooks/use-user-management-api/useUserManagementApi";
import { useAuth } from "pages/auth/hooks/useAuth";

export const useReceiver = () => {
    const { backendUser } = useAuth()
    const { fetchAnyUser } = useUserApi()
    const { fetchPartner } = usePartnerApi();
    const { setReceiver } = useContext(MessagingContext)
    const { fetchConnectionById } = useConnectionApi()
    const { fetchUserFunctionsByUser } = useUserManagementApi()


    const getReceiver = async (receiverId: string, shouldSetReceiver = true) => {
        const user: BackendUser = await fetchAnyUser(receiverId)
        let partner: BackendPartner;

        try {
            user?.partnerId && (partner = await fetchPartner(user?.partnerId));
        } catch (err) {

        }

        if (user) {
            const connection: Connection = await fetchConnectionById(backendUser?.id, user?.id)
            const userFunctions: UserFunction[] = await fetchUserFunctionsByUser(user?.id)

            const companyName = partner?.name;
            const isConnection = connection.status === 'accepted';
            const hasMessagePermission = userFunctions.some(permission => permission.name === 'DM');
            
            const receiver: Receiver = {
                name: `${user?.firstName} ${user?.lastName}`,
                id: user?.id,
                image: user?.image,
                companyName,
                isConnection,
                hasMessagePermission,
                companyId: partner?.id,
                restrictedStatus: user?.restrictedStatus
            }
            shouldSetReceiver && setReceiver(receiver)

            return receiver
        }
    }

    return {
        getReceiver,
        another: true,
    } as const
}